// LXRA Creator (Phase 3): bookings, packages, analytics, public booking request

export const ADMIN_BOOKINGS = {
  tab: 'admin-tab-bookings',
  tabBadge: 'admin-tab-bookings-badge',
  section: 'admin-bookings-section',
  statusFilter: 'admin-bookings-status-filter',
  searchInput: 'admin-bookings-search-input',
  newButton: 'admin-bookings-new-button',
  calendar: 'admin-bookings-calendar',
  clearDateButton: 'admin-bookings-clear-date-button',
  list: 'admin-bookings-list',
  empty: 'admin-bookings-empty',
  row: (id) => `admin-booking-row-${id}`,
  statusSelect: (id) => `admin-booking-status-${id}`,
  openButton: (id) => `admin-booking-open-${id}`,
  dialog: 'admin-booking-dialog',
  form: 'admin-booking-form',
  nameInput: 'admin-booking-name-input',
  emailInput: 'admin-booking-email-input',
  phoneInput: 'admin-booking-phone-input',
  packageSelect: 'admin-booking-package-select',
  serviceSelect: 'admin-booking-service-select',
  dateInput: 'admin-booking-date-input',
  timeInput: 'admin-booking-time-input',
  locationInput: 'admin-booking-location-input',
  priceInput: 'admin-booking-price-input',
  depositInput: 'admin-booking-deposit-input',
  statusFormSelect: 'admin-booking-form-status-select',
  photographerSelect: 'admin-booking-photographer-select',
  notesTextarea: 'admin-booking-notes-textarea',
  saveButton: 'admin-booking-save-button',
  deleteButton: 'admin-booking-delete-button',
  detail: 'admin-booking-detail',
  detailTitle: 'admin-booking-detail-title',
  detailBalance: 'admin-booking-detail-balance',
  detailPaid: 'admin-booking-detail-paid',
  paymentsList: 'admin-booking-payments-list',
  paymentRow: (id) => `admin-booking-payment-${id}`,
  paymentDelete: (id) => `admin-booking-payment-delete-${id}`,
  paymentAmountInput: 'admin-booking-payment-amount-input',
  paymentMethodSelect: 'admin-booking-payment-method-select',
  paymentNoteInput: 'admin-booking-payment-note-input',
  paymentAddButton: 'admin-booking-payment-add-button',
  editButton: 'admin-booking-edit-button',
  closeDetailButton: 'admin-booking-close-detail-button',
  requestedBanner: 'admin-bookings-requested-banner',
};

export const ADMIN_PACKAGES = {
  tab: 'admin-tab-packages',
  section: 'admin-packages-section',
  newButton: 'admin-packages-new-button',
  table: 'admin-packages-table',
  row: (id) => `admin-package-row-${id}`,
  editButton: (id) => `admin-package-edit-${id}`,
  deleteButton: (id) => `admin-package-delete-${id}`,
  activeSwitch: (id) => `admin-package-active-${id}`,
  dialog: 'admin-package-dialog',
  nameInput: 'admin-package-name-input',
  serviceSelect: 'admin-package-service-select',
  priceInput: 'admin-package-price-input',
  depositInput: 'admin-package-deposit-input',
  durationInput: 'admin-package-duration-input',
  descriptionTextarea: 'admin-package-description-textarea',
  includesTextarea: 'admin-package-includes-textarea',
  saveButton: 'admin-package-save-button',
};

export const ADMIN_ANALYTICS = {
  tab: 'admin-tab-analytics',
  section: 'admin-analytics-section',
  rangeSelect: 'admin-analytics-range-select',
  kpi: (key) => `admin-analytics-kpi-${key}`,
  revenueChart: 'admin-analytics-revenue-chart',
  serviceChart: 'admin-analytics-service-chart',
  statusList: 'admin-analytics-status-list',
  leadFunnel: 'admin-analytics-lead-funnel',
  empty: 'admin-analytics-empty',
};

export const BOOK_PAGE = {
  root: 'book-page',
  form: 'book-request-form',
  nameInput: 'book-name-input',
  emailInput: 'book-email-input',
  phoneInput: 'book-phone-input',
  serviceSelect: 'book-service-select',
  packageSelect: 'book-package-select',
  calendar: 'book-calendar',
  timeInput: 'book-time-input',
  locationInput: 'book-location-input',
  notesTextarea: 'book-notes-textarea',
  submitButton: 'book-submit-button',
  success: 'book-success-state',
  errorText: 'book-error-text',
  packageSummary: 'book-package-summary',
  loggedInNotice: 'book-logged-in-notice',
  loginHint: 'book-login-hint',
  noDateHint: 'book-no-date-hint',
};

export const BOOK_ENTRY = {
  contactLink: 'contact-request-booking-link',
  ctaSecondary: 'cta-request-booking-link',
  servicePackageLink: (i) => `service-package-request-link-${i}`,
};

export const MY_BOOKINGS = {
  root: 'client-my-bookings',
  empty: 'client-my-bookings-empty',
  row: (id) => `client-booking-row-${id}`,
  status: (id) => `client-booking-status-${id}`,
  bookAnotherLink: 'client-book-another-link',
};
